import clsx from 'clsx';
import { useFormikContext } from 'formik';
import React, { useContext } from 'react';

import { TableContext } from '../Table/TableContext';
import { PrimaryWhiteButton } from './Buttons';

interface ResetFormSubmitButtonProps {
  children: React.ReactNode;
  className?: string;
  detachMode?: boolean;
  isTableReset?: boolean;
}

const ResetFormSubmitButton: React.FC<ResetFormSubmitButtonProps> = ({
  children,
  className,
  detachMode = false,
  isTableReset = false,
}) => {
  const tableContext = useContext(TableContext);
  const { resetForm, values, setFieldValue, dirty, isValid } =
    useFormikContext<any>();
  const isDisabled = detachMode && !(isValid && dirty);

  const onResetForm = (e: any) => {
    resetForm();

    if (isTableReset) {
      const tempValues: Record<string, any> = {};
      Object.keys(values).map((key: string, _) => {
        if (typeof values[key] === 'boolean') {
          tempValues[key] = false;
        } else {
          tempValues[key] = '';
          setFieldValue(key, '');
        }
        return '';
      });

      tableContext?.setTableSelectedFilter(tempValues);
      tableContext?.handleSetTableFilterRecord({
        ...tempValues,
        page: 0,
      });
    }
  };

  return !isDisabled ? (
    <PrimaryWhiteButton
      onClick={onResetForm}
      type='button'
      className={clsx(className, 'in-form')}
    >
      {children}
    </PrimaryWhiteButton>
  ) : null;
};

export default ResetFormSubmitButton;
